import {
  ChallengeTimelineItemType,
  IChallengeTimelineItem,
  NonRepeatedChallengeTimelineItem,
  RepeatedChallengeTimelineItem,
} from 'features/challenge/ChallengeTimelineItem';
import {
  CHALLENGE_FIELDS,
  CHALLENGE_TYPE_FIELDS,
  TARGET_TYPES,
} from 'features/challenge/config';
import { ChallengeField } from 'features/timeline/config/types';

export const createChallenge = (
  challenge: IChallengeTimelineItem
): RepeatedChallengeTimelineItem | NonRepeatedChallengeTimelineItem => {
  return challenge.target.type === TARGET_TYPES.DUE_DATE
    ? new NonRepeatedChallengeTimelineItem(challenge)
    : new RepeatedChallengeTimelineItem(challenge);
};

export const reduceChallengesByType = (
  challenges: ChallengeTimelineItemType[]
) => {
  const result = {
    [CHALLENGE_FIELDS.CHALLENGES]: [],
    [CHALLENGE_FIELDS.ONE_TIME_CHALLENGES]: [],
  };

  return challenges.reduce((acc, val) => {
    acc[CHALLENGE_TYPE_FIELDS[val.type]].push(val);

    return acc;
  }, result as Record<ChallengeField, ChallengeTimelineItemType[]>);
};
